import {getCopy} from "../helpers";
import {isEmpty, isRfcValid, isNullOrEmpty, allValid} from "../Helpers/validationsHelper";
import ErrorManager from "../Helpers/ErrorManager";

class GenerateRequestDownloadFilesProcess {
    constructor(data) {
        this.data = getCopy(data);
    }

    getDataToSend() {
        this.validate(this.data);
        let result = this.setRFCToFilter(this.data);
        return result;
    }

    validate(data) {
        const {startDate, endDate, taxId, rfcsToFilter, rfcTPAccount} = data;
        if (taxId === '') {
            ErrorManager.throwError('Favor de Seleccionar un RFC');
        }
        if (isEmpty(startDate) || isEmpty(endDate)) {
            ErrorManager.throwError('Favor de seleccionar un rango de fechas para realizar la descarga');
        }
        if (rfcsToFilter.length > 0 && !allValid(rfcsToFilter, isRfcValid)) {
            ErrorManager.throwError('Verifique que los RFCs ingresados sean válidos');
        }
        if(rfcTPAccount && !isRfcValid(rfcTPAccount)){
            ErrorManager.throwError('Verifique que el RFC de cuenta a terceros sea válido');
        }
    }

    setRFCToFilter(data) {
        const {rfcsToFilter, type, documents} = data;
        if (rfcsToFilter.length > 0 && type === 'WebService') {
            switch (documents) {
                case 'Emision':
                    data.rfcReceptor = rfcsToFilter;
                    break;
                case 'Recepcion':
                    data.rfcEmisor = rfcsToFilter[0];
                    break;
                default:
                    break;
            }
        } else if (type === 'WebService') {
            data.rfcReceptor = null;
            data.rfcEmisor = null;
        }
        return data;
    }
}

export default GenerateRequestDownloadFilesProcess;